import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import OfficialDiaryAppService from '../../../../application/platform/sdp/official-diary/official-diary-app-service';
import { useFeedback } from '../../../../hooks/use-feedback';
import { ACTION_TYPES, useOfficialDiaryDetailDispatch } from "./official-diary-detail-context";

export const useOfficialDiaryDetailController = () => {
    const navigate = useNavigate();
    const { showError, withLoading } = useFeedback();
    const dispatch = useOfficialDiaryDetailDispatch();
    const { officialDailyId } = useParams();

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [officialDailyId]);

    async function loadData() {
        const id = Number(officialDailyId);
        if (!officialDailyId || Number.isNaN(id)) return;

        await withLoading(async () => {
            try {
                const [detail, file] = await Promise.all([OfficialDiaryAppService.getById(id), OfficialDiaryAppService.downloadFile(id)]);
                dispatch({ type: ACTION_TYPES.setOfficialDiaryDetail, payload: detail });
                dispatch({ type: ACTION_TYPES.setOfficialDiaryFile, payload: file });
            } catch (error: any) {
                showError('Não foi possível carregar os detalhes da edição', error);
            }
        });
    }

    function navigateBack() {
        navigate('/diario-oficial');
    }

    return { navigateBack };
}
